import { render, staticRenderFns } from "./WeekNumbers.vue?vue&type=template&id=08b55a63&scoped=true"
import script from "./WeekNumbers.vue?vue&type=script&lang=js"
export * from "./WeekNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b55a63",
  null
  
)

export default component.exports